(function(){
  'use strict';

  var logger = new (require('../helpers/logger.js'))("VPYoutube").setColor("darkred");
  var VideoPlayer = require('./videoplayer.js');
  var $script = require('scriptJs');
  var helper = require('../helpers/generic.js');
  $script("//www.youtube.com/iframe_api", 'YT');

  module.exports = VPYoutube;

  var defaults = {
  };

  function VPYoutube(mediaInstance, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage){
    var self = this;
    self.scriptReady = false;
    // NOTE: We cannot use global.onYouTubeIframeAPIReady here as it may already been called; Waiting for $script to be ready seems to work
    $script.ready('YT', function(){
      if(self._onScriptReady instanceof Function) {
          self._onScriptReady();
      }
      self.scriptReady = true;
    });

    this.autoplay = false;
    VideoPlayer.call(this, mediaInstance, inline, container, posterMediaImage, defaultQuality, defaults, options, playButtonImage, playButtonHoverImage);
    this.modifyOptionsWith(defaults); //merge the parents default options with the default options in this subclass
    this.modifyOptionsWith(options); //then merge the given options to overwrite the defaults

    //if (inline){
      if (helper.undefOrNull(posterMediaImage) || this.options.omitPosterElement){ //otherwise init on play
        logger.debug("should init without poster element");
        if (inline){
          this._initPlayer();
        } else {
          this.baseContainer.click(function(){
            self._play();
          });
        }
      } else {
        logger.debug("should init poster: ", posterMediaImage);
        this._initPoster();
      }
    //}
  }

  // subclass extends superclass
  VPYoutube.prototype = Object.create(VideoPlayer.prototype);
  VPYoutube.prototype.constructor = VideoPlayer;


  VPYoutube.prototype._initPlayer = function _initPlayer(){
    var vp = this;
    var media = vp.media;
    var autoplay = vp.autoplay;
    if (autoplay instanceof Boolean){
      autoplay = autoplay ? 1 : 0;
    }
    var container = (vp.container instanceof HTMLElement || vp.container.constructor.name == "HTMLDivElement") ? vp.container : vp.container[0]; //player needs native html element, not jquery; NOTE: both checks are needed for different browsers!

    var height = media.height(vp.defaultQuality);
    var width = media.width(vp.defaultQuality);
    if (vp.container.height > 0 && vp.container.width > 0){
      height = vp.container.height;
      width = vp.container.width;
    }

    var createPlayerOnApiReady = function(){
      logger.debug("script ready, waiting for API to become ready...");
      if (helper.undefOrNull(YT.Player)){ // API not yet ready; API will call window.onYouTubeIframeAPIReady when ready
        window.onYouTubeIframeAPIReady = onApiReady;
        logger.debug("...API will become ready through onYouTubeIframeAPIReady-callback!");
      } else { // API already is ready; directly call onApiReady
        logger.debug("...API was already ready!");
        onApiReady();
      }

      function onApiReady(){
        var ytOptions = {
          height: height,
          width: width,
          videoId: media.reference(),
          playerVars: { 'autoplay':autoplay },
          events: {
            'onStateChange': function(evt){
              vp._onStateChange(evt);
            }
          }
        };
        vp.player = new YT.Player(container, ytOptions);
        // NOTE: When initializing YT.Player on the container, the container
        // gets replaced by an iframe; So if you want to change the 'containers'
        // style, for example, you cannot use this.container; For that use:
        // $("#"+vp._containerId)
        logger.debug("Youtube API is ready....", ytOptions);
        window.onYouTubeIframeAPIReady = null;
      }
    };

    if(this.scriptReady) {
      createPlayerOnApiReady();
    } else {
      logger.debug("player NOT YET ready");
      this._onScriptReady = createPlayerOnApiReady;
    }

  };

  VPYoutube.prototype._onStateChange = function _onStateChange(evt){
    if (helper.undefOrNull(this._recentStates)){
      this._recentStates = [];
    } else {
      this._recentStates.length = 2; //just keep the last 5 states
    }

    var state = evt.data;
    var shouldDisplayPoster = false;
    if (!helper.undefOrNull(this.poster) && state === 0){ // ENDED
      for (var i=0; i<this._recentStates.length; i++){
        if (this._recentStates[i] > 0){ //video did already play at some time (so state was not just ENDED)
          shouldDisplayPoster = true;
          break;
        }
      }
    }

    if (this.inline && shouldDisplayPoster && !this.options.omitPosterElement){
      this._recentStates = null;

      this._onClose();
      this._initPoster();
    } else {
      this._recentStates.unshift(state);
    }

  };

  VPYoutube.prototype._play = function _play(container){
    if (!this.inline){
      logger.debug("init for overlay (autoplay)");
      this.autoplay = true;
      this._initPlayer();
    } else {
      logger.debug("playing inline");
      this.autoplay = !helper.undefOrNull(this.poster); //only autoplay if poster was set
      if (!helper.undefOrNull(this.poster) && !this.options.omitPosterElement){
        this._initPlayer();
      }
    }
    if (!self.scriptReady){
      self.autoplay = true;
    } else {
      vp.player.playVideo();
    }
  };

  VPYoutube.prototype._onClose = function _onClose(){
    if (!helper.undefOrNull(this.player)){
      this.player.destroy();
    }
    VideoPlayer.prototype._onClose.call(this);
    logger.debug("Youtube Player destroyed!");
  };

  VPYoutube.prototype._resizeIFrame = function resizeIFrame(width, height){
    var iframe = $("#"+this._containerId);
    if (iframe.length){
      iframe.attr("width", width);
      iframe.attr("height", height);
      iframe.css("width", width+'px');
      iframe.css("height", height+'px');
      iframe.css("max-width", width+'px');
      iframe.css("max-height", height+'px');
    }
    return this;
  };

  VPYoutube.prototype.resize = function resize(width, height){
    this._resizeIFrame(width, height);
  };

  VPYoutube.prototype.resizeForOverlay = function resizeForOverlay(width, height){
    if (!this.inline && !helper.undefOrNull(this.player)){
      this._resizeIFrame(width, height);
    }
    return this;
  };

  VPYoutube.prototype.resizeForInheritation = function resizeForInheritation(width, height){
    $(this.baseContainer).css({width: width+'px', height: height+'px'});
    if (this.inline){
      //changing this value seems to affect the player:
      this.container.css({width: width+'px', height: height+'px'});
      this._resizeIFrame(width, height);
    }
    return this;
  };

}());



//////////////////
// WEBPACK FOOTER
// ./src/VideoPlayer/videoplayer_youtube.js
// module id = 31
// module chunks = 0